import { useEffect, useState } from 'react';
import { EditOutlined, CloseOutlined, CheckOutlined } from '@ant-design/icons';
import { Table, Button, Form, notification, Tabs, Space } from 'antd';
import axios from 'axios';
import type { TabsProps } from 'antd';
import EditClientDeclensions from '../EditClientDeclensions';
import api from '@modules/Quotation/services';
import { useImmerReducer } from 'use-immer';
import CustomLoader from '@components/UI/CustomLoader/CustomLoader';
import useAuth from '@hooks/useAuth';

type Action = {
  type: 'getContractorData' | 'loading';
  payload?: any;
};
interface State {
  dataList: any;
  isLoad: boolean;
}
const initialState: State = {
  dataList: [],
  isLoad: false,
};
const reducer = (draft = initialState, action: Action) => {
  switch (action.type) {
    case 'getContractorData': {
      draft.dataList = action.payload;
      break;
    }
    case 'loading': {
      draft.isLoad = action.payload;
      break;
    }
    default:
      throw new Error(`Unknown action type: ${action.type}`);
  }
};
type TablePaginationPosition =
  | 'topLeft'
  | 'topCenter'
  | 'topRight'
  | 'bottomLeft'
  | 'bottomCenter'
  | 'bottomRight';

function ClientDeclensionsTable({ settings, subjisn, declensionData }) {
  const auth = useAuth();
  const [editingKey, setEditingKey] = useState<any>();
  const [state, dispatch] = useImmerReducer(reducer, initialState);
  const [documentInfoForm] = Form.useForm();
  const { dataList, isLoad } = state;

  const edit = (record) => {
    setEditingKey(record);
  };
  const columns = [
    {
      dataIndex: 'dataIndex',
      key: 'docno',
      width: '0',
      editable: true,
    },
    {
      dataIndex: 'classisn_name',
      key: 'classisn_name',
      width: '15%',
      editable: true,
    },
    {
      dataIndex: 'fullname',
      key: 'fullname',
      ellipsis: true,
      width: '25%',
      editable: true,
    },
    {
      dataIndex: 'shortname',
      key: 'shortname',
      ellipsis: true,
      width: '15%',
      editable: true,
    },
    {
      key: 'action',
      ellipsis: true,
      width: '10%',
      render: (_, record) => (
        <Button type="primary" className="mr-1" onClick={() => edit(record)}>
          <EditOutlined />
        </Button>
      ),
    },
  ];

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: `Редактирование информации`,
      children: (
        <EditClientDeclensions settings={settings} editingKey={editingKey} />
      ),
    },
  ];
  const generateDeclensions = async (values: any) => {
    try {
      dispatch({
        type: 'loading',
        payload: true,
      });
      const { data } = await api.quotation.generateDeclensions({
        pUserISN: auth.user.data?.user_info?.foreign_id,
        pSubjISN: subjisn,
      });

      if (data.data.length > 0) {
        dispatch({
          type: 'getContractorData',
          payload: JSON.parse(data.data).subhumanfio,
        });
      }
      dispatch({
        type: 'loading',
        payload: false,
      });
      setEditingKey(null);
    } catch (error) {
      dispatch({
        type: 'loading',
        payload: false,
      });
      let message;
      if (axios.isAxiosError(error)) {
        message = error.message;
      } else {
        message = String(error);
      }
      notification.info({
        message: 'Ошибка',
        description: message,
      });
    }
  };

  const onFinish = async (values: any) => {
    try {
      if (values.classisn) {
        const { data } = await api.quotation.editDeclension({
          pData: [values],
          pUserISN: auth.user.data?.user_info?.foreign_id,
        });

        if (data.data.length > 0) {
          dispatch({
            type: 'getContractorData',
            payload: JSON.parse(data.data).subhumanfio,
          });
        }

        setEditingKey(null);
      }
    } catch (error) {
      let message;

      if (axios.isAxiosError(error) && error.response) {
        message = error.response.data.message;
      } else {
        message = String(error);
      }

      notification.info({
        message: 'Ошибка',
        description: message,
      });
    }
  };
  useEffect(() => {
    if (declensionData) {
      dispatch({ type: 'getContractorData', payload: declensionData });
    }
  }, [declensionData]);

  const operations = (
    <Space>
      <Button
        size="small"
        onClick={() => {
          setEditingKey(null);
        }}
      >
        <CloseOutlined />
      </Button>
      <Button type="primary" size="small" htmlType="submit">
        <CheckOutlined />
      </Button>
    </Space>
  );

  useEffect(() => {
    if (editingKey) {
      documentInfoForm.setFieldsValue({
        ...editingKey,
        class_name: editingKey.classisn_name,
        subdocisn: editingKey.isn,
        docclassisn: editingKey.classisn,
      });
    }
  }, [editingKey]);

  return (
    <>
      <Button
        style={{ width: '100%', marginBottom: '15px' }}
        onClick={generateDeclensions}
      >
        Сгенерировать склонения
      </Button>
      <CustomLoader spinning={isLoad}>
        {dataList.map((field) => {
          if (
            editingKey &&
            Number(field.classisn) === Number(editingKey.classisn)
          ) {
            return (
              <Form
                name="documentInfoForm"
                layout="vertical"
                form={documentInfoForm}
                onFinish={onFinish}
              >
                <Tabs
                  defaultActiveKey="1"
                  items={items}
                  style={{ backgroundColor: '#F0F2F5', padding: '20px 30px' }}
                  tabBarExtraContent={operations}
                />
              </Form>
            );
          } else {
            return (
              <Table
                showHeader={false}
                columns={columns}
                dataSource={[field]}
                pagination={{
                  position: [
                    'none' as TablePaginationPosition,
                    'none' as TablePaginationPosition,
                  ],
                }}
                rowKey="docno"
              />
            );
          }
        })}
      </CustomLoader>
    </>
  );
}
export default ClientDeclensionsTable;
